import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'authentication',
  size: 'full',
  children: {
    company_selector: {
      path: 'company_selector',
      size: 'full',
    },
  },
} as const satisfies Location
